export default {
    差价合约:'ETF CFDs',
    把握全球:'Trade 100 popular global ETF CFDs, including equity, bond, thematic, and leveraged ETFs. No fund account required, bidirectional trading, with leverage!',
    即刻开户:'Open Account',
    优势:'Advantages',
    差价合约是一种:"ETF Contracts for Difference (CFDs) offer a flexible way to gain leveraged exposure to the world's leading ETFs. Ideal for traders looking to capture price movements and diversify their portfolio.",
    品种丰富:'Extensive Selection',
    支持100:'Trade 100 popular ETF CFDs across global markets',
    灵活交易:'Flexible Strategies',
    支持买入:'Go long or short to seize both rising and falling opportunities',
    无需持有:'No Ownership Required',
    无需持有资产:'Speculate on ETF price movements without holding the underlying assets',
    杠杆交易:'Leverage Available',
    杠杆配置:'Access 5:1 leverage to optimise capital efficiency',
    开设模拟账户:'Open Demo Account',
    开设真实账户:'Open Live Account',
    如何开始交易:'How to Start Trading',
    注册账号:'Register an Account',
    注册并登录:'Sign up and complete identity verification via the User Centre',
    下载MT5交易平台:'Download MT5 Platform',
    开通真实交易账号:'Open a real trading account on MetaTrader 5',
    开始交易:'Start Trading',
    选择ETF:'Choose from our range of ETF CFDs',
    即刻交易:'Trade Now',
    差价合约相关问题:'ETF CFDs-related Questions',
    ETF是什么:'1. What is an ETF?',
    ETF全称是:`ETF stands for "Exchange-Traded Fund." Simply put, it's like bundling a group of stocks into a package and trading that package on the stock market. For example, if you want to invest in tech stocks but don't know which ones to pick, buying a tech ETF is like owning shares of multiple tech companies such as Apple, Microsoft, and others all at once.`,
    有什么区别:'2. How are ETF CFDs different from traditional ETFs?',
    是差价合约交易:'ETF CFDs allow you to trade ETF price movements without owning the actual fund. No securities account is required, and there is no delivery of physical assets. ETF CFDs are more suitable for short-term, leveraged, and bi-directional trading strategies.',
    购买ETF才能交易:'3. Do I need to own an ETF to trade it?',
    通过EBC提供的ETF:'No. With EBC’s ETF CFD products, you can trade the price fluctuations of ETFs directly on the platform without owning any ETF shares.',
    交易会收取哪些费:'4. What fees apply to ETF CFD trading?',
    您无需支付传统ETF的管理费:'There are no traditional ETF management or brokerage fees. The main costs include the bid-ask spread and overnight financing charges. All applicable fees are transparently displayed on the platform in real time.',
    可以做空吗:'5. Can I short-sell ETF CFDs?',
    与传统ETF只能做多不:'Yes. Unlike traditional ETFs that only allow long positions, ETF CFDs support short-selling. This provides strategic flexibility in both volatile and declining markets.',
    适合新手交易者:'6. Are ETF CFDs suitable for beginners?',
    CFD产品具有杠杆属性:'ETF CFDs are leveraged products and are better suited for users with some trading experience and risk awareness. We recommend that beginners practise using a demo account to become familiar with the product before trading live.',
    市场报价:'All Products',
    查看所有产品:'View All Products',
}